import {Certifications} from "../../types";
import {AxiosResponse} from "axios";
import {ApiService} from "../api";
import {CertificationDTO} from "../../types/DTOs/CertificationDTO";
import {Log} from "../../utils/Log";

export class CertificationAPI extends ApiService {
    private constructor() {
        super();
    }

    async getCertifications(): Promise<Certifications[]> {
        const response: AxiosResponse<Certifications[]> = await this.api.get('/certification');
        return response.data;
    }

    async createCertifications(data: CertificationDTO): Promise<Certifications> {
        const response: AxiosResponse<Certifications> = await this.api.post('/certification', data);
        return response.data;
    }

    async updateCertifications(id: string, data: Partial<CertificationDTO>): Promise<Certifications> {
        Log.writeLogDebug('Passato');
        const response: AxiosResponse<Certifications> = await this.api.put(`/certification/${id}`, data);
        return response.data;
    }

    async deleteCertifications(id: string): Promise<void> {
        await this.api.delete(`/certification/${id}`);
    }
}